import {Component, Inject, OnInit} from '@angular/core';
import {
  AbstractControl, UntypedFormBuilder,
  FormControl,
  UntypedFormGroup,
  ValidationErrors,
  Validator,
  ValidatorFn,
  Validators
} from "@angular/forms";
import {AuthService} from "../auth/auth.service";
import {Router} from "@angular/router";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {timeout} from "rxjs/operators";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  codeMessage: string | undefined
  codeErrorMessage: string | undefined
  submitErrorMessage: string | undefined
  succeed = false;
  form: UntypedFormGroup;

  constructor(
    private router: Router,
    private auth: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ResetPasswordComponent>,
    private fb: UntypedFormBuilder
  ) {
    this.form = this.fb.group({
      username: [data, [Validators.required, Validators.email]],
      code: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
      password: ['', [Validators.required]],
      confirmPassword: ['']
    }, { validators: this.checkPasswords })
  }

  ngOnInit(): void {}

  checkPasswords: ValidatorFn = (group: AbstractControl):  ValidationErrors | null => {
    let pass = group.get('password')?.value;
    let confirmPass = group.get('confirmPassword')?.value
    return pass === confirmPass ? null : { notSame: true }
  }

  forgotPassword() {
    this.auth.forgotPassword(this.form.get('username')?.value.toLowerCase()).subscribe(
      () => this.codeMessage = "Email sent, if you're already register.",
      error => {
        console.log(error)
        this.codeMessage = error.message;
      }
    )
  }

  forgotPasswordSubmit() {
    this.auth.forgotPasswordSubmit(
      this.form.get('username')?.value.toLowerCase(),
      this.form.get('code')?.value,
      this.form.get('password')?.value,
    ).subscribe(
      () => {
        this.succeed = true
        setTimeout(() => this.dialogRef.close(), 3000)
      },
      error => {
        console.log(error)
        this.form.get('password')?.reset()
        this.form.get('confirmPassword')?.reset()
        this.submitErrorMessage = error.message;
      }
    )
  }
}
